import React from "react";
import styles from "./MenuAction.module.sass";
import { useGlobalValue } from "../../state/GlobalProvider";
import Checkbox from "../inputs/Checkbox/Checkbox";
import { UserRoles } from "../../utils/userRoles";
import CheckPermission from "../CheckPermission/CheckPermission";
const MenuAction = props => {
  const {
    onCheckBoxChange,
    isAllSelected
  } = props;
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckPermission, {
    roles: [UserRoles.ADMIN, UserRoles.OWNER, UserRoles.WRITER, UserRoles.PP_SUPPORT, UserRoles.SUPPORT]
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: styles["checkbox-all"],
    name: "select-all",
    value: "ALL",
    checked: isAllSelected,
    onChange: e => onCheckBoxChange("all", e.target.checked)
  }, /*#__PURE__*/React.createElement("h5", null, i18n`All`))));
};
export default MenuAction;